import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ReceptionTasks.css'; // can also reuse GroomerTasks.css if you prefer
import { StateContext } from '../../../../../StateProvider';

// Icons (reusing existing)
import appointmentIcon from '../../../../../../assets/Console/Landing/appointmentIcon.png';
import paymentIcon from '../../../../../../assets/Console/Landing/paymentIcon.png';
import petIcon from '../../../../../../assets/Console/Landing/petIcon.png';
import eventIcon from '../../../../../../assets/Console/Landing/eventIcon.png';
import incidentIcon from '../../../../../../assets/Console/Landing/incidentIcon.png';
import checkInAndOutIcon from '../../../../../../assets/Console/Landing/checkInAndOutIcon.png'
import promotionIcon from '../../../../../../assets/Console/Landing/promotionIcon.png'

import arrowIcon from '../../../../../../assets/Landing/arrowIcon.png';
import impactIcon from '../../../../../../assets/Landing/impactIcon.png';

import Footer from '../../../../../Footer';
import AnnouncementsFeed from '../../../Utils/AnnouncementsFeed';

function ReceptionTasks() {
  var ctx = useContext(StateContext) || {};
  var loggedIn = ctx.loggedIn;
  var financialSummary = ctx.financialSummary;
  var navigate = useNavigate();

  // Impact metric
  var _useState1 = useState(0), totalAnimalsHelped = _useState1[0], setTotalAnimalsHelped = _useState1[1];
  useEffect(function () {
    var totalRevenue = 0;
    if (financialSummary && financialSummary.totalRevenue) {
      totalRevenue = financialSummary.totalRevenue;
    }
    setTotalAnimalsHelped(calculateAnimalsHelped(totalRevenue, 20));
  }, [financialSummary]);

  function calculateAnimalsHelped(totalRevenue, supportPerAnimal) {
    if (typeof totalRevenue !== 'number') totalRevenue = 0;
    if (typeof supportPerAnimal !== 'number' || supportPerAnimal <= 0) supportPerAnimal = 20;
    var allocatedAmount = totalRevenue * 0.10;
    var result = Math.floor(allocatedAmount / supportPerAnimal);
    if (result < 0) result = 0;
    return result;
  }

  // Daily brief KPIs (placeholder-friendly, can wire to state later)
  var kpis = useMemo(function () {
    return {
      arrivalsToday: 12,
      departuresToday: 9,
      noShows: 1,
      callsToReturn: 4,
      outstandingBalances: 180
    };
  }, []);

  function handleMenuButtonClicked(page) {
    navigate(page);
    try { window.scrollTo(0, 0); } catch (e) {}
  }

  function handleImpactClicked(event) {
    if (!loggedIn) {
      if (event && event.preventDefault) event.preventDefault();
      navigate('/login');
    }
  }

  function formatMoney(n) {
    if (typeof n !== 'number') return '$0';
    try { return '$' + n.toLocaleString(); } catch (e) { return '$' + String(n); }
  }

  return (
    <>
      {/* Match GroomerTasks layout wrappers/classes for identical CSS */}
      <div className="reception-dashboard-container">
        <h4 className="console-header">Reception Task Board</h4>
        <h4 className="console-message">Keep check-ins smooth, phones friendly, and schedules tight.</h4>

        <div className="container store-menu-container">
          <div className="row">
            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={petIcon}
                  alt="Clients"
                  onClick={function () { handleMenuButtonClicked('/console/pets'); }}
                />
              </div>
              <p className="store-menu-button-title">Clients</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={appointmentIcon}
                  alt="Bookings"
                  onClick={function () { handleMenuButtonClicked('/console/tasks/reception/reception-bookings'); }}
                />
              </div>
              <p className="store-menu-button-title">Bookings</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={checkInAndOutIcon}
                  alt="Check In/Out"
                  onClick={function () { handleMenuButtonClicked('/console/tasks/reception/reception-check-ins'); }}
                />
              </div>
              <p className="store-menu-button-title">Check In/Out</p>
            </div>
          </div>

          <div className="row">
            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={paymentIcon}
                  alt="Payments"
                  onClick={function () { handleMenuButtonClicked('/console/tasks/reception/reception-payments'); }}
                />
              </div>
              <p className="store-menu-button-title">Payments</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={incidentIcon}
                  alt="Incident Report"
                  onClick={function () { handleMenuButtonClicked('/console/incident-log'); }}
                />
              </div>
              <p className="store-menu-button-title">Incident Report</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={promotionIcon}
                  alt="Promotions"
                  onClick={function () { handleMenuButtonClicked('/console/promotions'); }}
                />
              </div>
              <p className="store-menu-button-title">Promotions</p>
            </div>
          </div>
{/* 
          <div className="row">
            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={eventIcon}
                  alt="Shuttle"
                  onClick={function () { handleMenuButtonClicked('/console/tasks/reception/reception-shuttle'); }}
                />
              </div>
              <p className="store-menu-button-title">Shuttle</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={incidentIcon}
                  alt="Retail Sales"
                  onClick={function () { handleMenuButtonClicked('/console/tasks/reception/reception-retail'); }}
                />
              </div>
              <p className="store-menu-button-title">Retail</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={eventIcon}
                  alt="Events"
                  onClick={function () { handleMenuButtonClicked('/console/events'); }}
                />
              </div>
              <p className="store-menu-button-title">Events</p>
            </div>
          </div>

          <div className="row">
            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={eventIcon}
                  alt="Announcements"
                  onClick={function () { handleMenuButtonClicked('/console/announcements'); }}
                />
              </div>
              <p className="store-menu-button-title">Announcements</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={eventIcon}
                  alt="Memberships"
                  onClick={function () { handleMenuButtonClicked('/console/tasks/reception/reception-memberships'); }}
                />
              </div>
              <p className="store-menu-button-title">Memberships</p>
            </div>

            <div className="col store-menu-button-container">
              <div className="store-button-image-container">
                <img
                  className="store-menu-button-image"
                  src={eventIcon}
                  alt="Lost & Found"
                  onClick={function () { handleMenuButtonClicked('/console/lost-and-found'); }}
                />
              </div>
              <p className="store-menu-button-title">Lost & Found</p>
            </div>
          </div> */}

        </div>
      </div>

      {/* Daily Brief (shares the same classes for styling) */}
      <div className="staff-section-wrapper">
        <div className="staff-section-title">
          <span>📊</span> Front Desk Daily Brief
        </div>
        <div className="staff-section-grid">
          <div className="brief-card">Arrivals: <strong>{kpis.arrivalsToday}</strong></div>
          <div className="brief-card">Departures: <strong>{kpis.departuresToday}</strong></div>
          <div className="brief-card">No-Shows: <strong>{kpis.noShows}</strong></div>
          <div className="brief-card">Call-backs: <strong>{kpis.callsToReturn}</strong></div>
          <div className="brief-card">Unpaid Balances: <strong>{formatMoney(kpis.outstandingBalances)}</strong></div>
        </div>
      </div>

      <AnnouncementsFeed />

      <hr className="deals-breakline" />

      <div className="container">
        <Link to="/store/deals/impact" className="impact-highlight" onClick={handleImpactClicked}>
          <div className="impact-highlight-card">
            <div className="impact-highlight-card-items">
              <h3 className="impact-highlight-number">{totalAnimalsHelped}</h3>
              <h3 className="impact-highlight-paragraph">
                Animals helped. Your support enables us to contribute to animal rescue and care.
              </h3>
              <div className="impact-highlight-action">
                <h3 className="impact-highlight-button-title">SEE OUR IMPACT</h3>
                <img src={arrowIcon} className="impact-highlight-button" alt="see impact" />
              </div>
            </div>
            <div className="impact-highlight-card-items">
              <img className="impact-highlight-icon" src={impactIcon} alt="impact icon" />
            </div>
          </div>
        </Link>
      </div>

      <Footer />
    </>
  );
}

export default ReceptionTasks;
